import { ref } from 'vue';
import axios from 'axios';

export function useContact() {
  const contact = ref(null);
  const isLoading = ref(false);
  const error = ref(null);

  const fetchContact = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const response = await axios.get('/frontend/contact');
      contact.value = response.data;
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    contact,
    isLoading,
    error,
    fetchContact,
  };
}
